if (!customElements.get('sticky-atc')) {
  class StickyCart extends HTMLElement {
    constructor() {
      super();

      this.container = this;
      this.bindEventHandlers();
    }

    connectedCallback() {
      /* ===== Gather options for the current variant, handle sticky form offset, attach event listeners ===== */
      this.handleDOMContentLoaded();
      eventBus.on('variant:change', this.onDOMContentLoaded);
    }

    disconnectedCallback() {
      /* ===== Clean up event listeners ===== */
      this.removeEventListeners();
    }

    bindEventHandlers() {
      this.onDOMContentLoaded = this.handleDOMContentLoaded.bind(this);
    }

    removeEventListeners() {
      eventBus.of('variant:change', this.onDOMContentLoaded);
    }

    handleDOMContentLoaded() {
      if(this.observer) this.observer.disconnect();

      this.targetEls = document.querySelectorAll('.product--add-to-cart-button:not(.product--add-to-cart-button--sticky)');
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            this.container.classList.add('sticky-atc--open');
          }else {
            this.container.classList.contains('sticky-atc--open') && this.container.classList.remove('sticky-atc--open');
          }
        });
      }, {});
  
      this.targetEls.forEach(el => {
        this.observer.observe(el);
      })
    }
  }

  customElements.define('sticky-atc', StickyCart);
}